import { render, staticRenderFns } from "./SMain.vue?vue&type=template&id=530a6434&scoped=true&"
import script from "./SMain.vue?vue&type=script&lang=js&"
export * from "./SMain.vue?vue&type=script&lang=js&"
import style0 from "./SMain.vue?vue&type=style&index=0&id=530a6434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530a6434",
  null
  
)

export default component.exports